<template>
  <v-card>
    <card-avatar :fname="profileForm.firstName" :lname="profileForm.lastName" profile @upload="doUploadProfilePic">
    </card-avatar>
    <v-card-text>
      <message :messages="messages"></message>
      <form>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field :label="labels.email" v-model="profileForm.email" type="email" disabled hide-details></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field :label="labels.usrRefId" v-model="profileForm.usrRefId" disabled hide-details></v-text-field>
            </v-flex>
            <v-flex md8 xs12>
              <v-text-field :label="labels.firstName" v-model="profileForm.firstName" :error-messages="errors.collect('firstName')" v-validate="'required|max:128|name'" data-vv-name="firstName" :data-vv-as="labels.firstName"></v-text-field>
            </v-flex>
            <v-flex md4 xs12>
              <v-text-field :label="labels.lastName" v-model="profileForm.lastName" :error-messages="errors.collect('lastName')" v-validate="'required|max:128|name'" data-vv-name="lastName" :data-vv-as="labels.lastName"></v-text-field>
            </v-flex>
            <v-flex md6 xs12>
              <v-text-field :label="labels.mobileNo" v-model="profileForm.mobileNo" disabled hide-details></v-text-field>
            </v-flex>
            <v-flex md6 xs12>
              <v-text-field :label="labels.officeNo" v-model="profileForm.officeNo" type="tel" :error-messages="errors.collect('officeNo')" v-validate="'numeric|max:15'" data-vv-name="officeNo" :data-vv-as="labels.officeNo"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
                Update Profile
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import CardAvatar from '@/components/reusable/CardAvatar'
import MessageMixin from '@/mixins/message'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      labels: {
        firstName: 'First Name*',
        lastName: 'Last Name*',
        mobileNo: 'Mobile No.',
        officeNo: 'Office/Ext No.',
        email: 'Email',
        usrRefId: 'User Reference ID'
      },
      profileForm: {
        email: undefined,
        firstName: undefined,
        lastName: undefined,
        mobileNo: undefined,
        officeNo: undefined,
        usrRefId: undefined
      },
      submitting: false
    }
  },
  methods: {
    ...mapActions([
      'initProfile'
    ]),
    doUploadProfilePic() {
      this.$snotify.warning('Feature not ready')
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doUpdate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.$store.state.user.profile.menu.updateProfile
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.profileForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)

            // Reinit Profile
            this.initProfile()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    const { profile } = this.$store.state.user
    this.profileForm.email = profile.email
    this.profileForm.firstName = profile.firstName
    this.profileForm.lastName = profile.lastName
    this.profileForm.mobileNo = profile.mobileNo
    this.profileForm.officeNo = profile.officeNo
    this.profileForm.usrRefId = profile.usrRefId
  },
  components: {
    CardAvatar
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
